import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Params,Router } from '@angular/router';
import { GlobalService } from 'src/app/services/shared/global.service';
import { RoleUgService } from 'src/app/services/roles/role-ug.service';

@Component({
  selector: 'app-edit-role-ug',
  templateUrl: './edit-role-ug.component.html',
  styleUrls: ['./edit-role-ug.component.css']
})
export class EditRoleUgComponent implements OnInit{
  form!: FormGroup;
  public roleData:any;
  public roleId: string | null = null;
  public errorMessage: string | null = null;
  public successMessage: string | null = null;
  isProcessing: boolean = false;
  submitted: boolean = false;

  constructor(
      private roleService:RoleUgService,
      private formBuilder: FormBuilder,
      private router: Router,
      private activatedRoute: ActivatedRoute,
      private globalService: GlobalService,
    ){
      this.form = this.formBuilder.group({
      role_name: ['', Validators.required],
      'view-bl-list': [false],
      'edit-bl': [false],
      'view-bl': [false],
      'update-bl': [false],
      'delete-bl': [false],
      'print-qr-codes': [false],
      'print-bl':[false],
      'update-vsl-eta': [false],
      'transfer-vhcl':[false],
      'receive-vhcl':[false],
      'view-vhcls-in-transit':[false],
      'view-vhcl-transfer-hist':[false],
      'view-vhcl-list':[false],
      'view-vhcl-details':[false],
      'add-vhcl-photos':[false],
      'edit-vhcl':[false],
      'add-vhcl-atts':[false],
      'view-vhcl-atts':[false],
      'rplc-vhcl-atts':[false],
      'view-ug-all-stk':[false],
      'view-ug-all-avail-stk':[false],
      'view-ug-stk-enr':[false],
      'view-ug-stk-at-cfs':[false],
      'view-ug-sld-cars':[false],
      'mng-bnk-accts':[false],
      'mng-locations':[false],
      'mng-branches':[false],
      'mng-ug-users':[false],
      'mng-ug-roles':[false],
      'view-location':[false],
      'view-status':[false],
      'exp-view-bl-list':[false],
      'exp-view-bl-units':[false],
      'exp-view-stk-list':[false],
      'access-mobile-app':[false],
      'view-sp':[false],
      'view-ug-duty':[false],
      'view-ot-chg':[false],
      'view-ttl-cst':[false],
      'mob-upd-spare-parts':[false],
      'mob-view-vhcl-atts':[false],
      'take-web-photos':[false],
      'update-sp':[false],
      'add-web-vhcl-features':[false],
      'upload-web-photos':[false],
      'transfer-vhcl-sys':[false],
      'del-vhcl-photos':[false],
      'mob-view-stk-enr':[false],
      'mob-view-stk-port-cfs':[false],
      'view-port-photos-videos':[false],
      'view-transit-vhcls':[false],
      'add-vhcl-other-charges':[false],
      'rcv-agent-acty-notif':[false],
      'rcv-stockout-notif':[false],
    });
  }

  ngOnInit(): void {
    this.activatedRoute.paramMap.subscribe((param: Params)=>{
      this.roleId = param['get']('role_id')
    })

    if(this.roleId){
      this.fetchRole(this.roleId);
    }else{
      //Navigate back to users list with error
      this.globalService.setGlobalErrorMessage("Unable to select role for update!");
      this.router.navigate(['settings/roles-list']);
    }
  }

  fetchRole(roleId:string):void {
    this.roleService.getRoleData(roleId)
    .subscribe({
      next: (response) => {
        if (response && Object.keys(response).length === 0) {
          this.errorMessage="Oops! A problem was encountered while processing your request. Please refresh the page and try again!";
        }else{
          this.roleData = response;
          if(this.roleData.status==='no_data' || this.roleData.status.length===0){
            this.errorMessage=this.roleData.message;
          }else{
            if (this.roleData) {
              this.updateFormWithEditData();
            }
          }
        }
      },
      error: (error) => {
        this.errorMessage=error;
      }
    });
  }

  updateFormWithEditData() {
    // Loop through the editData.permissions array and set the corresponding form control values to true
    this.roleData.permissions.forEach((permission: string) => {
      if (this.form.controls.hasOwnProperty(permission)) {
        this.form.controls[permission].setValue(true);
      }
    });
  }

  handleSubmit():void{
    this.submitted=true;
    this.isProcessing = true;
    const selectedPermissions: string[] = Object.keys(this.form.value).filter(key => this.form.value[key]);

    // Remove the role_name from selectedPermissions array if it exists
    const roleIndex = selectedPermissions.indexOf('role_name');
    if (roleIndex !== -1) {
      selectedPermissions.splice(roleIndex, 1);
    }

    if (this.form.valid) {
      const formData = {
        role_name: this.form.get('role_name')?.value || '',
        permissions: selectedPermissions
      };

      this.roleService.updateRole(formData,this.roleId).subscribe(response => {
        if(response.status==='success'){

          this.submitted=false;
          this.isProcessing = false;
          this.globalService.setGlobalSuccessMessage(response.message);

          // Redirect back to roles list
          this.router.navigate(['settings/roles-list/ug']);
        }else if(response.status==='error'){
          this.submitted=false;
          this.isProcessing = false;
          this.globalService.setGlobalErrorMessage(response.message);
        }else{
          this.submitted=false;
          this.isProcessing = false;
          this.errorMessage="Oops! A problem was encountered while processing your request. Please try again or consult your system administrator.";
        }
      },
      error => {
        this.isProcessing = false;
        this.errorMessage=error;
      });
    }else{
      this.isProcessing = false;
    }
  }
}
